import React from 'react';
import Header from '../Navigation/Header/Header';
import Footer from '../Footer/Footer';
import classes from './Layout.module.css'
import { withRouter } from 'react-router-dom';
import { useThemes } from '../../../providers/ThemesContext'
import { useSettings } from '../../../providers/SettingsProvider';

const Layout = (props) => {

    const { showHeader, headerHeight, setHeaderHeight, showFooter } = useThemes();
    const { settings, contact, social, loading, datesClosed } = useSettings();
    return (
        <div className={classes.Page}>
            {showHeader && <Header
                cart={props.cart}
                addedToCart={props.addedToCart}
                clearIsAdded={props.clearIsAdded}
                datesClosed={datesClosed}
                loading={loading}
                contact={contact}
                settings={settings} 
                setHeaderHeight={setHeaderHeight} />}
            <main className={classes.Content} 
                style={{
                    marginTop: headerHeight,
                    minHeight: `calc(100vh - ${headerHeight}px)`,
                }}>
                {props.children}
            </main>
            {showFooter && <Footer 
                settings={settings} 
                datesClosed={datesClosed}
                contact={contact} 
                social={social} 
                loading={loading} />}
        </div>
    )
};

export default withRouter(Layout);